const SETTLEMENT_API_URLS = {
    createFlow: '/evolveCreateFlow',
    getFlow: '/evolveGetFlow',
    getFlows: '/evolveGetFlows',
    getSettlementResults: '/evolveGetSettlementResults',
    getSubFlows: '/evolveGetSubFlows',
    getSubFlowIO: '/evolveGetSubFlowIO',
    updateFlow: '/evolveUpdateFlow',
    startFlow: '/evolveStartFlow',
    executeFlow: '/evolveExecuteFlow',
    startMultipleFlows: '/evolveStartMultipleFlows',
    deleteFlow: '/evolveDeleteFlow',
    getFlowExecutionEnvironment: '/evolveGetFlowExecutionEnvironment',
    getAllVersionFlows: '/evolveGetAllVersionFlows',
    createNewFlowVersion: '/evolveCreateNewFlowVersion',
    getSettlements: '/evolveGetSettlements',
    getSettlementDetails: '/evolveGetSettlementDetails',
    getContractSettlementFlow: '/evolveGetContractSettlementFlow',
    downloadAllArtifacts: '/evolveDownloadAllArtifacts',
    downloadArtifact: '/evolveDownloadArtifact',
    getNodeAuditData: '/evolveGetNodeAuditData',
    getNodeCompareData: '/evolveGetNodeCompareData',
    getSettlement: '/evolveGetSettlement',
    getAllArtifacts: '/evolveGetAllArtifacts',
    createSubFlow: '/evolveCreateSubFlow',
    startDryRun: '/evolveStartDryRun',
    updateFavoriteNodeList: '/evolveUpdateFavoriteNodeList',
    getFlowExecutionEnvironments: '/evolveGetFlowExecutionEnvironments',
    getTotalExecEnvComparison: '/evolveGetTotalExecEnvComparison',
    getHeadFlow: '/evolveGetHeadFlow',
    compileFlow: '/evolveCompileFlow',
    getDbMetadata: '/evolveGetDbMetadata',
    getListCopyFromFlow: '/evolveGetListCopyFromFlow',
    replaceFlow: '/evolveReplaceFlow',
    pollingMultipleFlows: '/evolvePollingMultipleFlows',
    getSettlementResult: '/evolveGetSettlementResult',
    createSettlementResult: '/evolveCreateSettlementResult',
    getApprovedFlowTemplates: '/evolveGetApprovedFlowTemplates',
    getApprovedFlowTemplateNames: '/evolveGetApprovedFlowTemplateNames',
    getPendingFlowTemplates: '/evolveGetPendingFlowTemplates',
    createFlowTemplate: '/evolveCreateFlowTemplate',
    getListCopyFromFlowTemplate: '/evolveGetListCopyFromFlowTemplate',
    updateSettlementEngineRef: '/evolveUpdateSettlementEngineRef',
    getSettlementEngineRefInfo: '/evolveGetSettlementEngineRefInfo',
    getAncestorEngines: '/evolveGetAncestorEngines',
    getSettlementsByContractId: '/evolveGetSettlementsByContractId',
    getSettlementSummaryByUUID: '/evolveGetSettlementSummaryByUUID',
    getSettlementByExecutionEnvironmentUUID: '/evolveGetSettlementByExecutionEnvironmentUUID',
    getAIResponse: '/evolveGetAIResponse',
    getAllSchemaForContractNode: '/evolveGetAllSchemaForContractNode'
}

export default SETTLEMENT_API_URLS
